export default __webpack_public_path__ + "static/media/no-interest-statements.f5562056.svg";